const { Text } = require('account-ui');
const signals = require('../../../../../signals/account/orders');
const ordersComputedActions = require('../../../../../actions/computed/account/orders');
const currentOrderActions = require('../../../../../actions/account/current-order');
const SCHEMES = require('../../../../../helpers/scheme');
const css = require('./styles.css');

class IndividualOrderParameters {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: IndividualOrderParameters,
    children: [
        {
            name: 'order-amount-input',
            component: Text,
            props: {
                signals: { inputText: signals.amountInputText, blurText: signals.amountInputBlur },
                position: 'leftToRight',
                scheme: SCHEMES.number
            },
            watcher: {
                value: currentOrderActions.PATHS.orderAmount,
                isDisabled: ordersComputedActions.PATHS.isDisabledAmountField
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/orders/current-order/individual-order-parameters/index.js